// extracted by mini-css-extract-plugin
export default {"sellerContact":"SellerContact_sellerContact__H48xR"};